/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {$Checkbox} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Checkbox';
import {FC, $Container, $Sprite, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$BetSelectLandscape} from './BetSelect';
import {BUTTON_HIT_AREA} from './BottomPanelPortrait';
import {$PanelDisplay} from './PanelDisplay';
import {computedFormatCents} from '@gongxigames/framework/slotV2/JSX/helpersFormat';
import type {UIMainScreenUiProps} from './UIMainScreenUi';
import {uiElementsStore} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStore';
import {$WinAreaLandscape} from './WinArea/WinAreaLandscape';
import {uiMainScreenEmitter} from '../UIMainScreenEmitter';
import {$TurboBtn} from './TurboBtn';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {specialInfoZoneStore} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/specialInfoZoneStore';
import {Store} from '@gongxigames/framework/core';

const GRAY_PANEL_HEIGHT = 124;

export const $BottomPanelLandscape: FC<UIMainScreenUiProps> = (props) => {
    const balanceVal = computedFormatCents(props.balance);
    const panelHeight = specialInfoZoneStore.blackPanelHeight;
    const responsive = Store.computed(() => ({
        box: {y: '0', width: '100%'}, translate: {y: `${getProp(props.bottomPanelOffset)}px`}
    }) as ResponsiveConf);

    return <$Container name='bottom_panel_landscape'
        responsive={responsive}
    >
        <$Sprite
            name='background'
            texture='landscape_footer_sys_ui'
            responsive={{box: {y: '100%', width: '100%'}, translate: {y: `${-(panelHeight.value + GRAY_PANEL_HEIGHT)}px`}, updateWidth: true}}
        />
        <$Sprite
            name='background'
            texture='landscape_footer_sys_ui'
            scale={{x: 1, y: -1}}
            responsive={{box: {y: '100%', width: '100%'}, translate: {y: `${panelHeight.value + GRAY_PANEL_HEIGHT}px`}, updateWidth: true}}
        />
        <$Container
            name='buttons'
            responsive={{
                box: {y: '100%', width: '100%', height: `${GRAY_PANEL_HEIGHT}px`},
                translate: {y: `${-(panelHeight.value + GRAY_PANEL_HEIGHT)}px`}
            }}
        >
            <$Checkbox
                value={props.soundEnabled}
                name='sound_btn'
                disabled={uiElementsStore.sound_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                action={() => uiMainScreenEmitter.emit('PRESSED_SOUND')}
                texturePrefix='sound_btn'
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '-465px'}
                }}
            />
            <$Button
                name='menu_btn'
                disabled={uiElementsStore.menu_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                action={() => uiMainScreenEmitter.emit('PRESSED_MENU')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '-328px'}
                }}
            />
            <$WinAreaLandscape responsive={{box: {x: '50%', y: '50%'}}}/>
            <$TurboBtn
                currentLevel={props.turboLevel}
                disabled={uiElementsStore.turbo_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                visible={props.showTurboModeButton}
                action={() => uiMainScreenEmitter.emit('PRESSED_TURBO')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '328px'}
                }}
            />
            <$Button
                name='auto_btn'
                disabled={uiElementsStore.auto_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                visible={props.showAutoSpinButton}
                action={() => uiMainScreenEmitter.emit('PRESSED_AUTOPLAY_OPTIONS')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '465px'}
                }}
            />
            <$Button
                name='auto_on_btn'
                disabled={uiElementsStore.auto_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                visible={props.showAutoSpinOnButton}
                action={() => uiMainScreenEmitter.emit('PRESSED_AUTOPLAY_OPTIONS')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '465px'}
                }}
            />
            <$Button
                name='l_bet_btn'
                disabled={uiElementsStore.bet_panel_disabled}
                hitArea={null}
                action={() => uiMainScreenEmitter.emit('PRESSED_BET_SELECT')}
                responsive={{
                    box: {x: '100%', y: '50%'},
                    translate: {x: '-188px'},
                }}
            />
            <$PanelDisplay
                name='bet_display'
                label='spinLabel'
                isBetHidden={uiElementsStore.bet_panel_hidden}
                value={props.betFormatted}
                maxWidth={360}
                responsive={{
                    box: {x: '100%', y: '50%'},
                    translate: {x: '-188px'},
                }}
            />
            <$PanelDisplay
                name='credit_display'
                label='creditLabel'
                value={balanceVal}
                maxWidth={360}
                responsive={{
                    box: {x: '0', y: '50%'},
                    translate: {x: '188px', y: '0%'},
                }}
            />
        </$Container>
        <$BetSelectLandscape
            betCurrent={props.betCurrent}
            betFormatted={props.betFormatted}
            betList={props.betList}
            responsive={{
                box: {x: '100%', y: '100%'},
                translate: {x: '-188px', y: '-223px'},
            }}
            action={action => uiMainScreenEmitter.emit('PRESSED_BET_CHANGE', action)}
        />
    </$Container>;
};